/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionAuditAdminRowData
 */
export interface SubscriptionAuditAdminRowData {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAuditAdminRowData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAuditAdminRowData
     */
    projectId?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAuditAdminRowData
     */
    projectName?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAuditAdminRowData
     */
    companyName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAuditAdminRowData
     */
    subscriptionId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAuditAdminRowData
     */
    action?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAuditAdminRowData
     */
    actorType?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAuditAdminRowData
     */
    actorUserId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAuditAdminRowData
     */
    actorName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAuditAdminRowData
     */
    actorPhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAuditAdminRowData
     */
    actorEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAuditAdminRowData
     */
    source?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAuditAdminRowData
     */
    currentPackageName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAuditAdminRowData
     */
    newPackageId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAuditAdminRowData
     */
    newPackageName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionAuditAdminRowData
     */
    currentPackageNetPrice?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAuditAdminRowData
     */
    currentPackageCurrency?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionAuditAdminRowData
     */
    newPackageNetPrice?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAuditAdminRowData
     */
    newPackageCurrency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAuditAdminRowData
     */
    currentBillingCycle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAuditAdminRowData
     */
    newBillingCycle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAuditAdminRowData
     */
    previousStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionAuditAdminRowData
     */
    newStatus?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionAuditAdminRowData
     */
    previousCancelAtPeriodEnd?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionAuditAdminRowData
     */
    newCancelAtPeriodEnd?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof SubscriptionAuditAdminRowData
     */
    effectiveAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SubscriptionAuditAdminRowData
     */
    occurredAt?: Date;
}

/**
 * Check if a given object implements the SubscriptionAuditAdminRowData interface.
 */
export function instanceOfSubscriptionAuditAdminRowData(value: object): value is SubscriptionAuditAdminRowData {
    return true;
}

export function SubscriptionAuditAdminRowDataFromJSON(json: any): SubscriptionAuditAdminRowData {
    return SubscriptionAuditAdminRowDataFromJSONTyped(json, false);
}

export function SubscriptionAuditAdminRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionAuditAdminRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
        'projectName': json['projectName'] == null ? undefined : json['projectName'],
        'companyName': json['companyName'] === undefined ? undefined : json['companyName'] === null ? null : json['companyName'],
        'subscriptionId': json['subscriptionId'] === undefined ? undefined : json['subscriptionId'] === null ? null : json['subscriptionId'],
        'action': json['action'] == null ? undefined : json['action'],
        'actorType': json['actorType'] == null ? undefined : json['actorType'],
        'actorUserId': json['actorUserId'] === undefined ? undefined : json['actorUserId'] === null ? null : json['actorUserId'],
        'actorName': json['actorName'] === undefined ? undefined : json['actorName'] === null ? null : json['actorName'],
        'actorPhone': json['actorPhone'] === undefined ? undefined : json['actorPhone'] === null ? null : json['actorPhone'],
        'actorEmail': json['actorEmail'] === undefined ? undefined : json['actorEmail'] === null ? null : json['actorEmail'],
        'source': json['source'] == null ? undefined : json['source'],
        'currentPackageName': json['currentPackageName'] === undefined ? undefined : json['currentPackageName'] === null ? null : json['currentPackageName'],
        'newPackageId': json['newPackageId'] === undefined ? undefined : json['newPackageId'] === null ? null : json['newPackageId'],
        'newPackageName': json['newPackageName'] === undefined ? undefined : json['newPackageName'] === null ? null : json['newPackageName'],
        'currentPackageNetPrice': json['currentPackageNetPrice'] === undefined ? undefined : json['currentPackageNetPrice'] === null ? null : json['currentPackageNetPrice'],
        'currentPackageCurrency': json['currentPackageCurrency'] === undefined ? undefined : json['currentPackageCurrency'] === null ? null : json['currentPackageCurrency'],
        'newPackageNetPrice': json['newPackageNetPrice'] === undefined ? undefined : json['newPackageNetPrice'] === null ? null : json['newPackageNetPrice'],
        'newPackageCurrency': json['newPackageCurrency'] === undefined ? undefined : json['newPackageCurrency'] === null ? null : json['newPackageCurrency'],
        'currentBillingCycle': json['currentBillingCycle'] === undefined ? undefined : json['currentBillingCycle'] === null ? null : json['currentBillingCycle'],
        'newBillingCycle': json['newBillingCycle'] === undefined ? undefined : json['newBillingCycle'] === null ? null : json['newBillingCycle'],
        'previousStatus': json['previousStatus'] === undefined ? undefined : json['previousStatus'] === null ? null : json['previousStatus'],
        'newStatus': json['newStatus'] === undefined ? undefined : json['newStatus'] === null ? null : json['newStatus'],
        'previousCancelAtPeriodEnd': json['previousCancelAtPeriodEnd'] === undefined ? undefined : json['previousCancelAtPeriodEnd'] === null ? null : json['previousCancelAtPeriodEnd'],
        'newCancelAtPeriodEnd': json['newCancelAtPeriodEnd'] === undefined ? undefined : json['newCancelAtPeriodEnd'] === null ? null : json['newCancelAtPeriodEnd'],
        'effectiveAt': json['effectiveAt'] === undefined ? undefined : json['effectiveAt'] === null ? null : (new Date(json['effectiveAt'])),
        'occurredAt': json['occurredAt'] == null ? undefined : (new Date(json['occurredAt'])),
    };
}

export function SubscriptionAuditAdminRowDataToJSON(json: any): SubscriptionAuditAdminRowData {
    return SubscriptionAuditAdminRowDataToJSONTyped(json, false);
}

export function SubscriptionAuditAdminRowDataToJSONTyped(value?: SubscriptionAuditAdminRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'projectId': value['projectId'],
        'projectName': value['projectName'],
        'companyName': value['companyName'],
        'subscriptionId': value['subscriptionId'],
        'action': value['action'],
        'actorType': value['actorType'],
        'actorUserId': value['actorUserId'],
        'actorName': value['actorName'],
        'actorPhone': value['actorPhone'],
        'actorEmail': value['actorEmail'],
        'source': value['source'],
        'currentPackageName': value['currentPackageName'],
        'newPackageId': value['newPackageId'],
        'newPackageName': value['newPackageName'],
        'currentPackageNetPrice': value['currentPackageNetPrice'],
        'currentPackageCurrency': value['currentPackageCurrency'],
        'newPackageNetPrice': value['newPackageNetPrice'],
        'newPackageCurrency': value['newPackageCurrency'],
        'currentBillingCycle': value['currentBillingCycle'],
        'newBillingCycle': value['newBillingCycle'],
        'previousStatus': value['previousStatus'],
        'newStatus': value['newStatus'],
        'previousCancelAtPeriodEnd': value['previousCancelAtPeriodEnd'],
        'newCancelAtPeriodEnd': value['newCancelAtPeriodEnd'],
        'effectiveAt': value['effectiveAt'] == null ? value['effectiveAt'] : value['effectiveAt'].toISOString(),
        'occurredAt': value['occurredAt'] == null ? value['occurredAt'] : value['occurredAt'].toISOString(),
    };
}

